import { render, staticRenderFns } from "./AwiCustomData.vue?vue&type=template&id=13106897&"
import script from "./AwiCustomData.vue?vue&type=script&lang=js&"
export * from "./AwiCustomData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports